// extracted by mini-css-extract-plugin
export var wrapper = "SuccessModal-module--wrapper--527f8";
export var text = "SuccessModal-module--text--fadf6";
export var icon = "SuccessModal-module--icon--7bd79";